'use client';

import { env } from '@/env';
import { getApi } from '@/requests/api';
import { type IntegrationManifest } from '@pigello/pigello-matrix';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

export const useIntegrationManifests = (
  options?: Omit<
    UseQueryOptions<IntegrationManifest[] | boolean>,
    'queryKey' | 'queryFn' | 'staleTime'
  >
) => {
  const { data: manifests, ...rest } = useQuery<
    IntegrationManifest[] | boolean
  >({
    ...options,
    queryKey: ['integrationmanifests'],
    queryFn: async () =>
      await getApi({
        url: `${env.NEXT_PUBLIC_BASE_INTEGRATION_SERVICE_URL}/manifests${env.NEXT_PUBLIC_CLIENT_TYPE === 'local' || env.NEXT_PUBLIC_CLIENT_TYPE === 'dev' ? '?environment=dev' : ''}`,
        next: {
          revalidate: 3600,
        },
      }),
    staleTime: Infinity,
  });
  return {
    manifests: typeof manifests == 'boolean' ? [] : manifests,
    ...rest,
  };
};
